
export const imageUpload ={
    data(){
        return{
            image1: "",
            image2: "",
            url:null,
            imageUrl:"",
        }
    },
    methods:{
        onFileChange(e) {
            const file = e.target.files[0];
            this.image1 =file;
            let reader = new FileReader();
            reader.readAsDataURL( file );

            reader.onload = () => {
                  this.imageUrl = reader.result;
            };
            this.url = URL.createObjectURL(file);
        },
    }
}
